export const companyHost = process.env.VUE_APP_COMPANY_HOST || 'nemiPay';
export const configHostURL = process.env.VUE_APP_CONFIG_HOST_URL || '';
